
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M5 3a1 1 0 011 1v2.706a8 8 0 112 12.222 1 1 0 111-1.732A6 6 0 107.526 8H10a1 1 0 110 2H5a1 1 0 01-1-1V4a1 1 0 011-1z"}})])
          )
        }
      }
    